import type { CreateStyled } from '@emotion/styled';

export function deleteFromProps(props: any, key: string) {
  delete props[key];
}

export const transientOptions: Parameters<CreateStyled>[1] = {
  shouldForwardProp: (propName: string) => !propName.startsWith('$'),
};
